import { useMediaQuery } from '@wegroup/design-system';
import { bph } from '../utils/styledComponentsUtils';

const useIsAboveViewportHeight = (
  threshold: number | keyof typeof bph,
): boolean => {
  const pxThreshold =
    typeof threshold === 'string' ? bph[threshold] : threshold;

  const [isLargenThanThreshold] = useMediaQuery(
    `(min-height: ${pxThreshold}px)`,
    { ssr: false },
  );

  return isLargenThanThreshold;
};

export default useIsAboveViewportHeight;
